<template>
  <BrToolBar @search="buscar" :configFilter="configFilter" :labelTextField="labelTextField" :addlFilter="addlFilter">
    <!-- <BrModalCadastro /> -->
    <template v-slot:btnSelect>
      <slot name="btnSelect" />
    </template>
  </BrToolBar>
</template>

<script>
/**
 * MIXIN
 */
import toolbar from '@/views/mixins/toolbar'

export default {
  name: `ToolBarUsuarioWeb`,
  mixins: [toolbar],
  components: { 
    // BrModalCadastro: () => import('./modalCadastro'),
    BrToolBar: () => import('@/views/components/toolbar')
  }
}
</script>